import { useTranslation } from 'react-i18next';

export default function AboutSection() {
  const { t } = useTranslation();
  const list = t('about.list', { returnObjects: true }) as string[];

  return (
    <section className="bg-white">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-start">
          <div>
            <h2 className="text-2xl font-bold text-stone-900 md:text-3xl">{t('about.title')}</h2>
            <p className="mt-5 text-base leading-relaxed text-stone-700">{t('about.lead')}</p>
            <p className="mt-4 text-sm leading-relaxed text-stone-600 md:text-base">{t('about.p1')}</p>
            <p className="mt-4 text-sm leading-relaxed text-stone-600 md:text-base">{t('about.p2')}</p>
          </div>

          <div className="rounded-lg border border-stone-200 bg-stone-50/60 p-6">
            <h3 className="text-sm font-semibold text-stone-900">{t('about.listTitle')}</h3>
            <ul className="mt-4 space-y-3">
              {list.map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm text-stone-700">
                  <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-emerald-100 text-emerald-700">
                    <i className="ri-check-line w-3.5 h-3.5 flex items-center justify-center" aria-hidden="true" />
                  </span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}